import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { OnboardingModalComponent } from './components/onboarding-modal/onboarding-modal.component';
import { Web3ErrorToastComponent } from './components/web3-error-toast/web3-error-toast.component';
import { OnboardingModalService } from './services/onboarding-modal.service';
import { Wallet } from './services/wallet';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    OnboardingModalComponent,
    Web3ErrorToastComponent,
  ],
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  private wallet = inject(Wallet);

  // Eager-inject so each service's effects run from boot.
  readonly onboarding = inject(OnboardingModalService);

  ngOnInit() {
    // Fire-and-forget: wallet signals (activeAddress, activeBalance, etc.)
    // update reactively when ready. No need to block rendering.
    this.wallet.getOrSetPw().then(pw => this.wallet.signInOrCreateWallet(pw));
  }
}
